import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { GradeLevel } from '@app/infrastructure/models/grade-level';
import { UserStateService } from '@core/services/state/user-state.service';
import {
  GradeUnitListItemDTO,
  IGradeUnitListItemDTO,
} from '@models/grade-unit/grade-unit';
import { IPermissionCheck } from '@models/role';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-grade-unit',
  template: `
    <app-grade-unit-presentation
      [checkPermission]="checkPermission$ | async"
      [gradeUnit]="gradeUnit"
      [showUnitNumber]="showUnitNumber"
      (emitNavigateToDayList)="navigateToDayList($event)"
    ></app-grade-unit-presentation>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GradeUnitSmartComponent implements OnInit {
  @Input() public gradeUnit: IGradeUnitListItemDTO = new GradeUnitListItemDTO();
  @Input() public showUnitNumber: boolean = true;

  public checkPermission$: Observable<IPermissionCheck>;

  constructor(
    private router: Router,
    private userStateService: UserStateService,
  ) {}

  public ngOnInit(): void {
    this.checkPermission$ = this.checkUserPermissions();
  }

  public navigateToDayList(item: { grade: GradeLevel; unit: number }): void {
    const dayListPath = `${this.router.url}/${item.unit}/days`;
    this.router.navigateByUrl(dayListPath);
  }

  private checkUserPermissions(): Observable<IPermissionCheck> {
    return this.userStateService.checkUserPermissions();
  }
}
